<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <div class="form-modal-title">
          <h1>Genelate Tickets</h1>
        </div>
      </div>

      <div class="form-modal-body">
        <b-field label="Ticket Number">
          <b-input v-model="form.ticket_number" type="number" placeholder="Ticket Number" icon-pack="fas"
            icon="ticket-alt" expanded></b-input>
        </b-field>
      </div>

      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="submitForm()" type="is-primary">
          SUBMIT
        </b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  components: {},
  props: {
    event: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isModalActive: true,
    form: {
      stream_id: null,
      ticket_number: null,
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    submitForm() {
      let vm = this;
      const rules = {
        ticket_number: {
          run: (value) => {
            if (!value) {
              return "Ticket Number is required";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_loading = true;
        vm.form.stream_id = vm.event.id;
        vm.$store
          .dispatch("ADMIN_USER_GENERATE_STREAMING_TICKETS", vm.form)
          .then((response) => {
            vm.submit_loading = false;
            vm.$emit("saved", response.data.return);
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.submit_loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      }

    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 400px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 100px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>
  